<template>
    <div class="flex flex-wrap items-center justify-end gap-2 p-1 sm:gap-3">
        <!-- Header search is parked until results can respect per-role data access. -->
        <HeaderProfileV2></HeaderProfileV2>
    </div>
</template>
